import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 678.000000 452.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,452.000000) scale(0.100000,-0.100000)" >
<path d="M3220 4025 l0 -65 50 0 c28 0 50 5 50 10 0 6 -16 10 -35 10 -24 0
-35 5 -35 15 0 8 7 16 15 16 8 1 20 2 27 3 6 0 13 7 16 14 2 8 -7 12 -27 12
-17 0 -31 5 -31 10 0 6 13 10 29 10 17 0 32 4 35 9 7 10 -27 21 -66 21 -28 0
-28 -1 -28 -65z"/>
<path d="M3488 4079 c-30 -17 -22 -48 17 -65 42 -17 37 -39 -7 -30 -21 4 -28
2 -26 -7 3 -6 23 -13 46 -15 37 -3 42 0 48 22 8 32 1 42 -36 49 -40 8 -40 31
0 25 24 -4 30 -1 28 11 -4 19 -46 25 -70 10z"/>
<path d="M3340 4021 c0 -48 3 -61 15 -61 8 0 15 9 15 19 0 15 8 21 31 23 39 4
59 30 43 56 -7 11 -27 18 -58 20 l-46 3 0 -60z m80 19 c0 -15 -7 -20 -25 -20
-18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z"/>
<path d="M2740 4021 c0 -38 2 -41 28 -40 16 1 20 3 10 6 -12 3 -18 14 -18 33
0 16 -4 32 -10 35 -6 4 -10 -10 -10 -34z"/>
<path d="M4437 4052 c-21 -4 -32 -39 -17 -57 13 -16 46 -20 54 -7 3 5 -5 8
-17 8 -16 -1 -22 5 -22 19 0 16 8 21 38 23 35 3 37 2 37 -27 0 -17 5 -31 10
-31 6 0 10 13 10 29 0 16 6 31 13 34 14 5 -83 13 -106 9z"/>
<path d="M2312 4018 c3 -29 7 -33 33 -35 20 -1 23 0 8 4 -27 5 -30 20 -5 26
16 4 16 5 0 6 -26 2 -22 19 5 24 15 3 12 5 -11 6 -32 1 -33 -1 -30 -31z"/>
<path d="M2390 4014 c0 -32 2 -35 26 -32 55 6 59 68 4 68 -28 0 -30 -3 -30
-36z m48 4 c-5 -34 -38 -37 -38 -4 0 20 5 26 21 26 15 0 20 -5 17 -22z"/>
<path d="M2483 4015 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M2512 4043 c10 -2 18 -17 21 -36 l4 -32 1 32 c1 21 8 33 20 36 9 3
-1 5 -23 5 -22 0 -32 -2 -23 -5z"/>
<path d="M2585 4020 c-20 -38 -19 -43 5 -28 15 10 22 10 32 0 23 -23 28 -12
11 23 -20 43 -28 44 -48 5z m30 0 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2
10 4 10 3 0 8 -4 11 -10z"/>
<path d="M2660 4015 c0 -32 2 -35 29 -35 36 0 41 7 34 43 -4 22 -11 27 -34 27
-26 0 -29 -3 -29 -35z m40 15 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1
10 9 10 9 0 16 -4 16 -10z m2 -32 c-9 -9 -15 -9 -24 0 -9 9 -7 12 12 12 19 0
21 -3 12 -12z"/>
<path d="M2805 4018 c2 -29 6 -33 31 -35 21 -1 23 0 7 4 -27 5 -31 23 -5 23
15 1 14 2 -3 12 -19 12 -19 12 5 19 24 7 23 7 -6 8 -30 1 -32 -1 -29 -31z"/>
<path d="M3823 4043 c11 -3 17 -14 17 -34 0 -17 4 -28 10 -24 5 3 6 13 3 22
-4 9 1 21 12 29 17 13 15 14 -21 13 -21 -1 -31 -3 -21 -6z"/>
<path d="M3890 4015 c0 -33 2 -35 33 -34 23 1 26 3 10 6 -27 5 -31 23 -5 24
12 0 10 3 -8 11 l-25 11 25 7 25 8 -27 1 c-25 1 -28 -2 -28 -34z"/>
<path d="M3970 4035 c10 -12 10 -18 0 -30 -7 -9 -10 -19 -6 -22 4 -4 11 -1 16
7 7 11 11 11 24 1 18 -15 22 -1 5 16 -15 15 -3 33 22 33 14 0 19 -7 19 -30 0
-16 5 -30 10 -30 6 0 10 13 10 29 0 16 6 32 13 34 6 3 -9 6 -35 6 -31 1 -48
-3 -48 -11 0 -9 -3 -9 -12 0 -17 17 -33 15 -18 -3z"/>
<path d="M4130 4015 c0 -33 2 -35 33 -34 23 1 26 3 10 6 -27 5 -31 23 -5 23
15 1 14 2 -3 12 -19 12 -19 12 5 19 23 6 23 7 -7 8 -31 1 -33 -1 -33 -34z"/>
<path d="M4210 4013 c0 -31 2 -34 13 -21 6 9 19 18 27 21 10 4 7 6 -7 6 -13 1
-23 5 -23 10 0 5 10 12 23 14 19 4 18 4 -5 6 -26 1 -28 -2 -28 -36z"/>
<path d="M4280 4013 c0 -31 2 -34 13 -21 6 9 19 18 27 21 10 4 7 6 -7 6 -13 1
-23 5 -23 10 0 5 10 12 23 14 19 4 18 4 -5 6 -26 1 -28 -2 -28 -36z"/>
<path d="M4342 4018 c3 -29 7 -33 33 -35 20 -1 23 0 8 4 -27 5 -31 23 -5 23
15 1 14 2 -3 12 -19 12 -19 12 5 19 23 6 22 7 -8 8 -32 1 -33 -1 -30 -31z"/>
<path d="M2090 3919 c0 -27 34 -96 59 -120 59 -56 83 -58 561 -59 411 -1 441
-2 490 -21 29 -11 54 -18 56 -16 2 1 -21 22 -51 45 l-54 42 -465 3 -464 2 -44
30 c-25 18 -52 49 -65 75 -19 37 -23 40 -23 19z"/>
<path d="M4665 3899 c-23 -49 -65 -83 -120 -98 -28 -8 -168 -11 -465 -9 -268
2 -414 6 -395 12 43 13 60 27 43 37 -25 16 -43 9 -89 -35 -25 -24 -67 -58 -94
-75 -27 -17 -47 -31 -44 -31 2 0 29 8 59 17 47 14 123 18 520 22 513 7 491 4
558 72 32 33 56 87 50 114 -2 8 -12 -4 -23 -26z"/>
<path d="M3030 3870 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M3728 3863 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3040 3841 c-24 -7 -23 -7 12 -24 62 -29 99 -19 60 16 -20 18 -32 19
-72 8z"/>
<path d="M5914 3773 c-10 -49 -52 -176 -73 -225 -11 -26 -17 -47 -13 -47 20 3
21 -4 7 -37 -20 -49 -20 -50 15 -12 17 18 38 41 47 50 9 10 19 15 23 13 11 -7
19 62 14 125 -2 30 -4 79 -4 108 -1 57 -6 67 -16 25z m3 -115 c-3 -7 -5 -2 -5
12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-10 -60 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-31 -35 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1
-15 -2 -18z"/>
<path d="M807 3776 c-14 -35 -8 -282 8 -326 8 -23 12 -46 9 -51 -3 -5 -2 -14
2 -21 13 -21 23 24 17 80 -4 33 -2 52 5 52 17 0 20 82 4 149 -9 36 -18 59 -20
53 -2 -7 -8 -9 -13 -6 -6 4 -6 11 1 20 8 9 9 22 3 41 -8 23 -10 24 -16 9z m16
-141 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m24 -17 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M1876 3620 c-35 -33 -82 -75 -105 -92 -37 -29 -51 -48 -35 -48 3 0
42 33 87 74 45 41 96 86 112 100 17 14 24 26 17 26 -7 0 -41 -27 -76 -60z"/>
<path d="M4795 3654 c17 -15 63 -56 104 -93 79 -72 101 -87 101 -73 0 5 -16
22 -37 37 -20 16 -68 57 -106 92 -39 35 -75 63 -81 63 -6 0 3 -12 19 -26z"/>
<path d="M1925 3582 c-33 -31 -82 -75 -110 -98 l-49 -40 188 -215 c237 -270
225 -257 234 -242 5 7 14 47 21 88 11 69 14 75 37 76 13 1 29 3 34 4 6 1 35 3
65 4 30 0 55 5 55 10 0 6 -12 23 -26 38 -15 15 -102 114 -194 218 -91 105
-173 195 -181 202 -12 9 -26 1 -74 -45z"/>
<path d="M4640 3528 c-194 -225 -246 -285 -277 -319 -18 -18 -33 -37 -33 -40
0 -4 40 -10 89 -13 l90 -7 11 -57 c6 -31 13 -69 16 -84 7 -35 18 -35 47 -1 12
15 40 47 62 72 23 26 86 98 140 161 55 63 115 132 135 153 19 22 35 43 35 48
0 7 -213 200 -218 198 -1 0 -45 -50 -97 -111z"/>
<path d="M882 3520 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M904 3482 c-16 -11 -44 -55 -44 -69 0 -8 11 -12 29 -11 23 2 27 6 22
23 -4 17 -6 18 -9 3 -4 -19 -22 -25 -22 -8 0 6 8 22 17 36 l16 26 13 -24 c7
-12 13 -18 14 -12 0 18 -25 44 -36 36z"/>
<path d="M5810 3469 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5786 3434 c-8 -21 -8 -21 7 -27 10 -4 13 2 9 19 -5 28 -8 30 -16 8z"/>
<path d="M2537 3414 c-22 -37 -58 -378 -49 -476 7 -83 19 -42 14 50 -5 100 8
203 39 309 16 53 19 78 12 99 -5 15 -12 24 -16 18z"/>
<path d="M2708 3398 c-91 -144 -202 -478 -169 -511 8 -8 11 -8 11 2 0 7 5 9
10 6 6 -3 10 -1 10 4 0 6 14 30 31 54 21 28 42 45 66 52 44 12 56 35 19 35
-14 0 -26 2 -26 5 0 8 24 48 37 62 7 8 33 40 59 73 26 33 51 60 55 60 8 0 31
71 25 77 -2 2 -28 -24 -59 -59 -66 -76 -167 -228 -193 -292 -19 -46 -34 -59
-34 -30 0 9 9 55 21 103 26 108 78 219 124 265 28 29 35 43 35 76 0 46 -2 48
-22 18z"/>
<path d="M4176 3386 c-4 -20 -2 -44 3 -54 22 -41 51 -224 52 -329 1 -72 4 -95
8 -68 11 62 2 218 -20 350 -21 129 -33 157 -43 101z"/>
<path d="M4005 3370 c1 -31 9 -48 34 -72 41 -40 82 -121 109 -213 25 -85 37
-165 26 -165 -5 0 -25 35 -46 78 -35 75 -161 254 -211 300 l-25 24 7 -34 c5
-18 25 -51 45 -73 27 -29 33 -41 22 -43 -19 -4 -10 -30 20 -60 13 -13 24 -29
24 -35 0 -7 18 -21 40 -31 22 -10 40 -23 40 -29 0 -7 9 -23 20 -37 11 -14 20
-33 20 -43 0 -10 5 -15 10 -12 6 3 10 -1 10 -9 0 -9 5 -16 11 -16 6 0 8 -7 5
-16 -6 -15 4 -13 30 8 14 10 -4 102 -43 218 -28 84 -130 300 -142 300 -4 0 -7
-18 -6 -40z"/>
<path d="M5890 3385 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M5861 3334 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5841 3234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4953 3001 c-6 -27 -10 -60 -7 -73 4 -19 3 -20 -4 -4 -7 15 -11 12
-24 -23 -9 -22 -14 -50 -11 -61 5 -20 6 -20 24 1 11 12 19 27 20 33 0 6 4 -1
9 -15 4 -15 4 -46 -1 -70 -5 -24 -12 -59 -15 -77 -4 -18 -11 -35 -15 -38 -17
-10 -10 -44 9 -44 17 0 34 31 46 81 9 42 9 166 0 180 -10 15 -12 37 -14 112
-1 26 -2 47 -3 47 -1 0 -8 -22 -14 -49z m-19 -125 c-3 -9 -10 -16 -15 -16 -6
0 -5 9 1 21 13 24 24 20 14 -5z"/>
<path d="M6119 3028 c-1 -7 -1 -16 0 -20 0 -5 -3 -8 -9 -8 -5 0 -10 -5 -10
-11 0 -6 -13 -27 -30 -46 -16 -18 -30 -41 -30 -50 0 -20 -77 -123 -92 -123 -6
0 -8 -3 -5 -7 4 -3 18 4 31 16 26 25 42 15 31 -20 -5 -16 -3 -20 11 -17 13 2
17 14 18 52 1 31 6 50 14 52 7 1 8 0 2 -3 -13 -6 -13 -43 0 -43 13 0 30 44 29
73 0 21 -1 21 -9 2 -8 -20 -9 -19 -9 1 -1 12 6 27 14 34 12 10 15 9 15 -6 0
-37 22 4 23 44 1 22 5 38 10 35 4 -2 7 10 7 26 0 30 -9 44 -11 19z"/>
<path d="M600 3023 c0 -5 4 -23 9 -39 5 -16 12 -42 15 -57 4 -15 10 -25 15
-22 5 2 12 -2 15 -11 9 -24 7 -31 -4 -14 -17 27 -11 -3 14 -64 13 -32 31 -65
40 -74 14 -14 16 -14 22 1 3 9 10 17 16 17 5 0 6 -6 3 -12 -4 -7 1 -4 9 6 18
23 20 36 6 36 -5 0 -10 11 -10 25 0 14 -7 28 -16 32 -8 3 -20 17 -25 31 -5 14
-12 22 -16 18 -10 -10 -33 15 -33 36 0 10 -4 16 -10 13 -6 -3 -7 1 -4 9 3 9 1
16 -5 16 -6 0 -11 6 -11 13 -1 15 -30 55 -30 40z m90 -164 c-7 -11 -14 -18
-17 -15 -3 3 0 12 7 21 18 21 23 19 10 -6z m49 -90 c-15 -9 -49 -12 -49 -4 0
3 8 13 18 23 14 15 19 16 31 4 12 -12 12 -15 0 -23z"/>
<path d="M1760 2957 c0 -29 -5 -58 -11 -64 -15 -15 -7 -199 11 -235 7 -16 21
-28 31 -28 16 0 16 4 -3 63 -11 34 -22 70 -25 80 -4 13 -1 16 12 11 13 -5 14
-9 3 -15 -10 -7 -9 -9 5 -9 14 0 16 -6 12 -27 l-6 -28 15 30 15 30 -5 -30 c-4
-23 -3 -27 5 -15 10 14 8 44 -5 108 -3 16 -1 21 7 16 7 -4 10 -2 8 5 -3 7 -8
11 -13 9 -14 -5 -27 41 -19 69 5 20 3 25 -8 21 -12 -5 -14 2 -11 28 3 21 0 34
-7 34 -7 0 -11 -21 -11 -53z m17 -79 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3
4 -12 1 -19z"/>
<path d="M670 2920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1978 2883 c-62 -4 -70 -11 -39 -30 15 -10 34 -9 88 2 88 19 193 19
317 0 107 -16 132 -15 64 4 -92 25 -263 34 -430 24z"/>
<path d="M4465 2880 c-49 -4 -103 -11 -120 -15 -101 -24 -82 -29 41 -10 125
19 230 19 318 0 48 -10 74 -11 87 -4 29 15 23 29 -13 29 -18 1 -76 2 -128 4
-52 2 -135 1 -185 -4z"/>
<path d="M5998 2860 c-30 -34 -20 -42 12 -8 17 19 26 38 17 38 -1 0 -14 -13
-29 -30z"/>
<path d="M1844 2788 c0 -23 6 -38 14 -38 6 0 12 -5 12 -11 0 -5 -4 -7 -10 -4
-6 4 -10 -5 -10 -19 0 -14 5 -26 10 -26 6 0 5 -6 -2 -14 -7 -8 -17 -12 -22 -9
-4 3 -4 8 2 12 5 3 6 15 2 26 -6 17 -7 16 -12 -8 -3 -17 0 -34 8 -42 11 -10
11 -15 1 -18 -6 -3 18 -6 56 -6 51 -1 67 2 67 13 0 8 -6 17 -12 19 -9 4 -8 6
3 6 8 1 20 -4 27 -11 8 -8 14 -5 22 16 5 15 10 31 10 35 0 5 8 11 18 14 52 17
145 56 132 56 -23 1 -172 -45 -226 -68 -25 -12 -48 -21 -50 -21 -2 0 -1 12 2
28 4 19 -1 33 -14 48 -11 12 -22 30 -25 40 -3 10 -4 2 -3 -18z"/>
<path d="M2312 2809 c-40 -5 -87 -13 -105 -19 l-32 -10 35 5 c19 2 73 7 119
11 101 8 102 -4 4 -36 -66 -21 -150 -60 -232 -108 -38 -22 -41 -27 -25 -33 25
-10 65 -11 61 -1 -1 4 2 8 6 9 5 0 21 12 35 26 46 42 157 89 137 58 -3 -5 -1
-12 5 -16 7 -4 7 -12 0 -26 -10 -18 -9 -18 17 -7 15 7 37 17 48 23 11 7 27 11
35 11 8 -1 25 14 37 32 l23 33 -21 28 c-23 31 -32 32 -147 20z"/>
<path d="M4274 2791 c-13 -14 -41 -50 -61 -81 -21 -30 -46 -62 -55 -72 -10
-10 -18 -23 -18 -28 0 -14 39 12 45 30 3 8 15 26 25 39 19 22 21 23 39 7 17
-15 19 -16 25 -1 3 9 6 29 6 45 0 20 6 31 20 35 11 3 20 13 20 22 0 13 12 15
91 8 166 -12 296 -59 318 -114 15 -35 25 -39 41 -13 9 14 10 12 5 -10 -5 -28
-5 -28 50 -28 42 0 55 3 55 15 0 8 3 15 8 15 4 0 5 24 3 52 -2 29 -6 47 -8 41
-3 -7 -11 -13 -18 -13 -21 0 -28 -19 -15 -35 17 -21 7 -19 -79 15 -93 36 -248
77 -327 85 -140 15 -144 14 -170 -14z"/>
<path d="M5950 2805 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M1186 2782 c81 -70 135 -111 174 -130 105 -53 176 -115 207 -182 14
-30 24 -120 13 -120 -7 0 -5 -87 2 -121 12 -54 -302 24 -489 123 -30 16 -55
23 -58 18 -3 -6 1 -10 9 -10 9 0 16 -4 16 -9 0 -5 20 -18 45 -30 25 -12 45
-25 45 -29 0 -5 19 -15 43 -21 23 -7 47 -17 52 -21 10 -8 85 -30 120 -35 38
-5 160 -36 187 -46 15 -6 31 -23 37 -38 7 -18 10 33 10 177 l1 202 -26 40
c-15 22 -29 38 -32 36 -11 -11 -304 165 -350 211 -7 7 -19 13 -25 13 -7 0 2
-13 19 -28z"/>
<path d="M788 2780 c-3 -8 0 -21 7 -27 10 -10 14 -9 19 3 3 8 2 12 -3 9 -5 -3
-11 3 -13 12 -3 15 -5 15 -10 3z"/>
<path d="M4860 2771 c-6 -12 -7 -21 -1 -21 10 0 24 30 17 37 -2 3 -9 -5 -16
-16z"/>
<path d="M4321 2766 c-10 -12 -10 -16 -2 -16 7 0 30 -9 52 -19 22 -11 46 -18
54 -15 16 7 97 -29 115 -51 7 -8 19 -15 28 -15 8 0 23 -7 33 -16 10 -9 30 -14
46 -12 26 3 23 6 -39 41 -71 41 -207 101 -249 112 -17 4 -30 1 -38 -9z"/>
<path d="M5909 2763 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M5985 2770 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M5490 2759 c-13 -6 -27 -13 -30 -17 -3 -4 -25 -20 -50 -36 -25 -16
-61 -40 -80 -52 -19 -13 -47 -28 -63 -33 -15 -6 -32 -23 -38 -38 -6 -16 -15
-36 -20 -45 -5 -10 -9 -47 -9 -83 0 -50 3 -63 13 -59 9 3 15 24 16 60 3 106
25 133 166 212 35 19 138 103 125 101 -3 0 -16 -5 -30 -10z"/>
<path d="M4911 2744 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2506 2705 c15 -22 37 -49 48 -60 20 -20 20 -20 1 10 -10 17 -32 44
-48 60 l-30 30 29 -40z"/>
<path d="M800 2690 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M845 2690 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"/>
<path d="M740 2670 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M915 2660 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M786 2652 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M5960 2649 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4522 2599 c-31 -38 -14 -38 23 1 18 19 23 30 14 29 -8 0 -24 -13
-37 -30z"/>
<path d="M2095 2579 c58 -31 75 -48 101 -104 20 -41 24 -66 24 -144 0 -110
-19 -162 -76 -210 -49 -40 -96 -51 -213 -51 l-101 0 0 -77 c0 -62 4 -83 20
-103 11 -14 20 -28 20 -32 0 -5 -61 -8 -135 -8 -83 0 -135 -4 -135 -10 0 -5
-6 -10 -14 -10 -26 0 -29 -21 -6 -45 l21 -23 -28 -10 c-15 -6 -22 -11 -15 -11
7 -1 10 -5 7 -11 -3 -5 3 -10 14 -10 10 0 21 -5 23 -10 2 -7 54 -12 135 -13
73 -2 135 -5 138 -9 3 -3 -13 -14 -37 -24 -52 -21 -332 -34 -351 -15 -6 6 -22
11 -36 11 -27 0 -111 37 -111 50 0 4 21 6 48 3 35 -3 43 -2 32 6 -8 6 -26 11
-40 12 l-25 1 25 8 c20 7 21 8 5 9 -11 0 -29 -6 -39 -14 -23 -17 -46 -20 -46
-5 0 6 10 10 23 11 17 1 15 3 -11 12 -19 6 -31 15 -28 23 3 8 -9 14 -32 19
-20 3 -46 8 -57 11 -16 4 -17 3 -5 -5 8 -6 25 -11 37 -11 12 0 25 -5 29 -11 4
-8 -1 -9 -16 -4 -14 5 -20 3 -16 -3 3 -6 20 -13 36 -17 17 -4 28 -11 25 -15
-3 -5 -13 -6 -23 -3 -9 3 6 -11 33 -31 28 -20 61 -39 75 -43 14 -3 30 -10 36
-14 46 -36 284 -44 394 -14 81 22 188 25 175 5 -3 -5 -2 -10 3 -10 6 0 13 15
16 34 5 27 12 35 35 39 l29 6 -16 66 c-11 47 -20 65 -32 65 -23 0 -40 20 -40
47 0 20 3 21 24 13 19 -7 25 -5 29 9 3 13 18 20 52 26 26 3 56 12 67 18 14 9
20 9 26 0 5 -8 13 -9 22 -3 24 16 40 11 40 -11 0 -11 5 -17 10 -14 6 4 10 57
9 128 0 78 -4 115 -9 102 -5 -11 -9 -15 -9 -8 -2 20 11 43 23 43 20 0 -16 246
-43 303 -23 48 -77 91 -126 101 -27 5 -26 4 10 -15z m75 -494 c-7 -8 -20 -15
-29 -15 -11 0 -8 5 9 14 33 19 35 19 20 1z m-55 -25 c-3 -5 -12 -10 -18 -10
-7 0 -6 4 3 10 19 12 23 12 15 0z m-202 -17 c-8 -3 -13 -25 -13 -59 0 -41 6
-64 26 -95 22 -36 24 -43 12 -56 -11 -10 -21 -11 -39 -4 -16 6 -18 10 -7 10
22 1 28 33 9 47 -21 16 -29 143 -10 155 8 5 19 8 24 8 6 0 4 -3 -2 -6z"/>
<path d="M4580 2586 c0 -7 9 -25 20 -39 19 -24 20 -40 20 -321 0 -283 -1 -296
-21 -331 -21 -35 -21 -53 0 -40 6 3 20 24 32 46 19 38 19 51 13 332 -6 286 -7
293 -30 330 -26 40 -34 45 -34 23z"/>
<path d="M5840 2589 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5920 2589 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4107 2568 c-53 -28 -113 -101 -134 -161 -14 -41 -18 -83 -18 -192 0
-133 1 -143 28 -197 35 -71 133 -165 180 -172 17 -3 50 -7 72 -10 38 -5 38 -4
-10 10 -82 25 -119 43 -158 80 -70 66 -107 174 -107 309 0 156 42 247 146 318
61 40 61 48 1 15z"/>
<path d="M3624 2566 c-5 -12 0 -38 11 -65 10 -25 21 -77 25 -116 l7 -70 2 75
c2 41 2 87 1 102 -1 14 3 29 9 33 7 4 11 -10 11 -39 0 -25 3 -46 8 -46 15 0 0
96 -19 120 -18 22 -19 22 -10 3 21 -43 4 -47 -21 -6 -15 26 -17 27 -24 9z"/>
<path d="M3906 2555 c-23 -23 -26 -33 -25 -98 1 -40 3 -63 6 -52 3 11 11 25
19 31 8 7 14 16 12 20 -1 5 4 33 11 62 7 29 11 55 8 58 -3 3 -17 -7 -31 -21z
m-9 -87 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M2874 2535 c9 -13 20 -42 25 -62 l9 -38 1 38 c1 38 -22 87 -41 87 -6
0 -3 -11 6 -25z"/>
<path d="M3162 2540 c-9 -14 -11 -78 -10 -232 1 -117 3 -185 5 -150 2 36 8 60
13 57 13 -8 13 -262 0 -270 -5 -3 -9 2 -8 12 0 10 0 38 -1 63 -3 44 -3 44 -12
15 -19 -63 -1 -155 31 -155 36 0 52 85 25 136 -12 23 -15 69 -15 212 0 169 2
186 20 209 23 30 26 62 6 88 -12 17 -16 18 -31 5 -16 -14 -17 -13 -11 8 9 27
5 28 -12 2z"/>
<path d="M2821 2535 c39 -47 52 -89 52 -169 0 -110 -25 -162 -104 -217 l-22
-15 29 -55 c16 -30 31 -56 35 -59 3 -3 23 -38 45 -77 21 -40 42 -73 47 -73 10
0 9 28 -2 34 -19 12 -101 164 -101 187 1 24 1 24 25 -6 16 -19 28 -26 33 -19
4 6 17 10 30 9 l24 -2 -4 166 c-3 164 -4 167 -35 227 -17 33 -40 67 -50 74
-17 14 -17 14 -2 -5z"/>
<path d="M2230 2531 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M3497 2506 c10 -13 19 -23 21 -21 5 5 -22 45 -31 45 -4 0 0 -11 10
-24z"/>
<path d="M865 2510 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"/>
<path d="M5840 2509 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3536 2460 c8 -16 61 -88 77 -105 6 -5 1 5 -9 23 -20 35 -81 109 -68
82z"/>
<path d="M920 2446 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
<path d="M3692 2410 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1837 2414 c-11 -12 -8 -172 4 -179 6 -4 12 -5 14 -4 1 2 5 44 6 93
4 84 -4 110 -24 90z"/>
<path d="M5077 2413 c-15 -2 -25 -8 -22 -13 3 -5 13 -6 22 -3 12 5 14 3 8 -7
-6 -10 -4 -12 9 -7 11 4 29 -1 46 -13 27 -19 50 -26 50 -14 0 10 -64 64 -75
63 -5 -1 -22 -4 -38 -6z"/>
<path d="M5725 2400 c-54 -35 -59 -38 -136 -73 -162 -75 -439 -142 -439 -107
0 6 6 10 14 10 8 0 16 7 20 15 3 8 12 15 20 15 10 0 21 19 31 52 17 58 12 73
-12 39 -14 -20 -22 -23 -63 -19 l-48 5 1 -56 c1 -101 -2 -128 -13 -111 -7 11
-10 1 -9 -35 0 -40 2 -46 9 -27 5 12 12 22 15 22 4 0 3 -4 0 -10 -3 -5 -4 -10
0 -10 3 0 10 11 15 25 11 30 29 37 135 59 108 22 150 33 210 57 11 4 35 12 52
18 18 5 64 30 103 55 39 25 73 46 76 46 3 0 17 11 32 25 32 30 28 32 -13 5z"/>
<path d="M995 2390 c10 -11 22 -17 28 -13 6 4 3 12 -8 20 -28 20 -41 16 -20
-7z"/>
<path d="M2481 2339 c-1 -63 1 -70 16 -67 18 4 20 14 12 100 -7 67 -26 43 -28
-33z"/>
<path d="M4850 2365 c0 -41 19 -73 28 -47 2 7 19 12 38 12 36 0 94 34 94 56 0
7 8 14 18 17 9 2 -27 5 -80 5 l-98 2 0 -45z"/>
<path d="M4430 2396 c0 -3 17 -13 38 -21 20 -9 42 -22 48 -30 5 -7 23 -17 40
-21 l29 -7 -25 20 c-41 33 -130 73 -130 59z"/>
<path d="M1904 2344 c3 -26 6 -55 6 -65 0 -13 7 -19 24 -19 31 0 50 24 50 65
0 43 -19 65 -57 65 -30 0 -30 0 -23 -46z"/>
<path d="M2537 2383 c-4 -3 -7 -26 -7 -51 l0 -45 47 7 c26 3 50 12 55 19 12
18 10 51 -4 65 -13 13 -80 17 -91 5z"/>
<path d="M4245 2366 c-14 -14 -31 -40 -37 -56 -5 -17 -15 -27 -20 -24 -17 11
-4 -184 13 -201 12 -12 14 -6 14 41 0 30 -4 58 -10 62 -19 14 -16 50 7 75 37
40 60 41 96 7 18 -17 32 -26 32 -20 0 16 23 12 81 -17 73 -35 99 -60 99 -95 0
-24 4 -28 30 -28 l30 0 0 100 0 100 -29 0 c-17 0 -32 4 -35 9 -14 22 -125 64
-183 69 -56 4 -63 2 -88 -22z"/>
<path d="M4580 2365 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M5023 2350 c-36 -33 -40 -40 -19 -40 16 0 66 45 66 60 0 17 -13 11
-47 -20z"/>
<path d="M3914 2358 c-4 -7 -10 -51 -13 -98 -3 -62 -7 -77 -12 -55 -4 17 -7
-30 -8 -105 0 -80 3 -129 8 -121 6 9 11 -3 16 -38 4 -28 10 -49 14 -46 8 4 51
-48 51 -62 0 -10 35 -25 125 -53 83 -25 165 -61 165 -71 0 -4 18 -2 40 3 51
13 60 5 30 -27 -28 -30 -25 -31 34 -5 85 38 306 67 306 41 0 -5 14 -12 30 -16
20 -4 32 -14 36 -30 5 -22 34 -44 34 -26 0 10 60 6 125 -9 94 -21 190 -32 260
-27 81 5 218 49 285 92 l45 29 -33 7 c-45 9 -46 13 -12 26 25 9 30 9 30 -3 0
-22 12 -17 55 23 27 24 31 31 13 20 -15 -9 -40 -17 -55 -17 -34 0 -99 -22
-115 -38 -7 -7 -28 -13 -48 -13 -23 -1 -27 -3 -12 -6 12 -2 22 -8 22 -13 0 -5
-10 -11 -22 -13 -17 -3 -15 -5 9 -6 40 -1 63 7 63 25 0 8 10 14 26 14 22 0 25
-2 14 -15 -7 -8 -18 -15 -25 -15 -7 0 -15 -6 -18 -14 -3 -8 -25 -17 -49 -21
-24 -4 -58 -14 -77 -21 -21 -9 -77 -15 -150 -16 -98 -1 -128 2 -191 23 l-75
23 55 7 c30 4 99 5 153 2 90 -5 101 -3 127 16 16 11 34 21 40 21 5 0 10 7 10
15 0 8 -7 15 -15 15 -23 0 -18 11 29 62 24 26 42 49 40 50 -1 2 12 4 29 4 40
2 211 46 215 55 2 4 23 13 48 20 24 7 44 17 44 21 0 4 5 8 11 8 6 0 28 14 49
30 21 17 43 30 49 30 6 0 11 5 11 10 0 15 -18 12 -38 -7 -9 -10 -28 -24 -42
-30 -14 -7 -32 -17 -40 -22 -8 -5 -26 -13 -40 -18 -14 -6 -41 -17 -60 -25 -46
-20 -130 -37 -200 -40 l-55 -3 -1 35 c-1 84 -5 110 -14 110 -5 0 -11 -49 -12
-112 l-3 -113 -334 -3 c-283 -2 -337 0 -350 12 -15 13 -22 13 -61 -2 -33 -12
-76 -16 -165 -16 -105 1 -128 4 -182 26 -116 49 -165 107 -199 239 -17 64 -23
256 -9 278 3 6 4 11 1 11 -3 0 -8 -5 -12 -12z"/>
<path d="M769 2343 c6 -12 16 -25 21 -28 17 -11 11 5 -11 28 l-21 22 11 -22z"/>
<path d="M5938 2326 c-10 -7 -18 -19 -18 -25 0 -7 -4 -10 -8 -7 -5 3 -34 -12
-65 -33 -45 -30 -54 -40 -44 -50 10 -10 6 -12 -18 -10 -16 2 -39 -2 -50 -8
-19 -11 -18 -12 8 -18 15 -4 40 -4 55 -1 15 4 33 8 41 9 8 2 19 11 26 20 7 9
17 17 24 17 6 0 11 7 11 15 0 12 -7 14 -27 9 -41 -10 -45 -14 -31 -31 12 -15
11 -15 -9 -3 -20 13 -20 15 -5 27 9 7 25 13 35 13 9 0 17 5 17 10 0 6 8 10 18
10 9 0 27 16 40 35 25 39 25 40 0 21z"/>
<path d="M806 2303 c-11 -11 -6 -22 7 -17 10 4 12 -3 9 -26 -4 -26 -1 -31 14
-28 13 2 18 -2 16 -13 -1 -9 4 -19 12 -22 10 -4 12 0 9 14 -3 10 0 19 6 19 6
0 10 -5 9 -11 -2 -6 3 -13 10 -14 7 -2 8 -1 3 1 -5 3 -7 16 -5 30 3 19 0 24
-16 24 -11 0 -20 4 -20 9 0 12 -46 41 -54 34z"/>
<path d="M920 2231 c11 -8 12 -11 2 -11 -7 0 -11 -4 -7 -9 3 -6 -2 -14 -12
-20 -17 -9 -17 -10 0 -28 9 -11 17 -23 17 -27 0 -4 7 -14 15 -22 8 -8 19 -23
24 -32 5 -9 13 -13 17 -9 5 5 2 12 -5 17 -8 4 -11 15 -8 25 4 9 3 13 -3 10 -9
-6 -30 25 -30 44 0 5 14 9 30 9 17 -1 34 3 38 7 4 4 -3 5 -16 2 -17 -4 -22 -1
-20 11 2 11 -3 16 -15 14 -9 -2 -16 2 -15 9 2 6 -4 14 -12 16 -13 4 -13 3 0
-6z"/>
<path d="M5702 2155 c-19 -10 -20 -14 -8 -18 9 -4 16 -2 16 3 0 6 7 10 15 10
8 0 15 5 15 10 0 13 -9 11 -38 -5z"/>
<path d="M970 2150 c20 -13 53 -13 45 0 -3 6 -18 10 -33 10 -21 0 -24 -2 -12
-10z"/>
<path d="M3446 2143 c-3 -4 -7 -29 -7 -57 -1 -44 -2 -47 -9 -21 -6 24 -8 15
-10 -40 -5 -113 3 -145 35 -145 10 0 8 9 -4 34 -10 19 -16 47 -13 67 3 28 8
35 28 37 16 1 27 -4 30 -16 11 -33 39 -82 47 -82 4 0 12 -11 17 -25 8 -22 16
-25 56 -25 l46 0 -17 26 c-44 67 -193 253 -199 247z"/>
<path d="M4850 2095 c0 -25 0 -48 -1 -52 0 -4 4 -9 10 -11 6 -2 9 2 6 10 -4
10 10 12 70 10 41 -2 75 0 75 4 0 4 -10 18 -22 31 -32 34 -14 40 32 9 64 -42
83 -32 28 16 -33 28 -66 36 -83 19 -14 -12 -85 -22 -85 -11 0 4 -7 10 -15 14
-12 4 -15 -4 -15 -39z"/>
<path d="M5760 2105 c0 -8 -4 -15 -10 -15 -5 0 -10 -7 -10 -15 0 -8 5 -15 10
-15 6 0 10 5 10 11 0 6 10 19 23 30 l22 18 -22 1 c-14 0 -23 -6 -23 -15z"/>
<path d="M2480 2020 c0 -76 4 -98 23 -130 12 -22 28 -40 36 -40 12 0 11 3 -1
18 -35 39 -39 60 -28 125 16 91 18 96 36 73 17 -24 18 -9 1 19 -7 11 -24 21
-39 23 l-28 3 0 -91z"/>
<path d="M5680 2094 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M1020 2090 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5131 2061 c-23 -19 -30 -30 -22 -35 11 -7 79 41 80 57 2 15 -25 5
-58 -22z"/>
<path d="M4520 2060 c-19 -11 -29 -19 -22 -20 14 0 72 28 72 35 0 9 -15 4 -50
-15z"/>
<path d="M1000 2050 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2531 2000 c-1 -54 3 -70 23 -95 l24 -30 12 26 c10 23 8 34 -24 95
l-35 69 0 -65z"/>
<path d="M3550 2056 c0 -11 74 -109 111 -145 14 -15 28 -33 31 -41 3 -8 9 -11
14 -7 5 4 4 11 -1 15 -6 4 -26 27 -45 52 -79 103 -109 137 -110 126z"/>
<path d="M1588 2040 c-11 -27 -17 -130 -7 -130 5 0 12 6 15 14 7 19 0 134 -8
116z"/>
<path d="M1037 2025 c2 -8 19 -21 36 -30 18 -8 39 -19 47 -24 8 -5 35 -17 60
-26 25 -9 53 -21 63 -27 11 -5 42 -14 70 -19 29 -5 73 -13 98 -18 25 -5 67
-12 95 -15 42 -5 51 -3 62 14 12 19 10 20 -51 20 -85 0 -256 26 -298 46 -19 9
-69 33 -111 54 -42 20 -74 32 -71 25z"/>
<path d="M2272 2020 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M4580 1993 c0 -28 3 -34 10 -23 13 20 13 47 0 55 -6 4 -10 -9 -10
-32z"/>
<path d="M2787 1853 c-59 -2 -95 -8 -92 -13 4 -6 -12 -11 -37 -12 -24 -1 -54
-2 -68 -3 -14 -1 -107 -2 -207 -3 l-183 -2 0 -23 c0 -35 50 -83 95 -91 22 -4
56 -16 77 -27 41 -21 50 -13 18 16 -31 28 -24 35 36 35 40 0 106 16 230 55 96
30 185 55 197 55 12 0 29 5 37 10 8 5 11 9 5 8 -5 -1 -54 -4 -108 -5z m-40
-19 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M1305 1770 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z"/>
<path d="M5338 1753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1510 1730 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M1440 1709 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4267 1633 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M3100 1480 c-65 -7 -197 -28 -340 -55 -41 -7 -115 -29 -165 -48 l-90
-34 75 4 c101 7 155 -9 203 -58 l37 -40 0 76 c0 55 3 75 13 75 7 0 18 5 25 12
6 6 17 13 24 14 7 1 40 7 72 13 44 8 62 8 67 0 4 -8 21 -9 50 -3 24 4 51 7 60
5 9 -1 35 2 58 8 22 5 41 7 41 5 0 -2 -9 -18 -20 -36 -11 -18 -20 -35 -20 -38
0 -3 19 -4 41 -2 26 3 44 0 49 -8 5 -9 9 -9 14 -1 4 6 2 11 -4 11 -6 0 -9 4
-6 9 3 4 -4 17 -15 27 -20 18 -20 18 23 31 57 17 99 16 145 -2 47 -19 70 -50
52 -71 -7 -9 -8 -14 -1 -14 6 0 14 -10 18 -22 4 -13 16 -29 26 -37 19 -13 19
-14 -3 -37 -12 -13 -28 -24 -36 -24 -7 0 -13 -4 -13 -8 0 -5 -16 -16 -36 -26
-20 -9 -34 -19 -31 -22 6 -6 60 21 89 45 21 17 118 23 135 9 32 -26 4 18 -84
135 -47 62 -54 82 -23 74 11 -3 23 -1 26 4 3 6 10 6 17 1 17 -13 133 -22 144
-11 12 12 116 -8 156 -30 30 -17 32 -21 35 -84 2 -37 5 -67 8 -67 3 0 16 13
30 29 39 46 99 64 196 59 l82 -5 -92 33 c-134 49 -287 80 -502 105 -88 9 -436
9 -530 -1z"/>
<path d="M1675 1371 c2 -4 22 -16 45 -26 22 -10 40 -22 40 -26 0 -5 7 -6 15
-2 27 10 11 25 -48 43 -31 10 -55 15 -52 11z"/>
<path d="M4983 1357 c-24 -6 -43 -17 -43 -24 0 -20 28 -15 68 12 39 27 39 27
-25 12z"/>
<path d="M2090 1332 l-55 -27 65 -6 c72 -6 106 -19 165 -63 44 -34 95 -86 95
-99 0 -5 -17 5 -39 22 -46 36 -147 61 -251 61 -62 0 -240 -38 -280 -60 -15 -9
-11 -10 65 -24 17 -3 41 -9 55 -13 24 -6 24 -6 -5 20 l-30 26 25 -1 c14 0 47
7 73 16 26 9 75 17 108 17 51 1 64 -3 86 -25 14 -14 41 -28 60 -32 25 -5 31
-10 24 -17 -15 -15 -14 -27 2 -22 6 2 50 6 97 9 66 5 92 11 115 28 16 12 37
21 47 21 25 -2 -72 87 -160 147 -71 48 -76 50 -140 49 -52 0 -80 -6 -122 -27z"/>
<path d="M4391 1320 c-33 -22 -90 -67 -125 -99 -36 -33 -82 -67 -103 -76 -41
-18 -170 -27 -179 -14 -3 5 -11 9 -17 9 -7 0 -3 -7 7 -15 28 -22 125 -19 188
5 28 11 54 24 58 29 3 6 20 0 41 -15 25 -17 53 -26 95 -29 32 -3 84 -7 114 -9
46 -4 50 -3 28 5 -39 15 -35 24 15 39 72 21 73 22 60 27 -31 11 -7 18 70 21
66 2 90 -1 121 -17 24 -13 49 -18 65 -15 l26 5 -28 -25 c-15 -14 -27 -26 -25
-26 13 0 150 29 154 32 4 5 -15 11 -146 47 -136 38 -313 21 -396 -38 -60 -42
-55 -25 9 36 71 67 127 95 207 102 l65 6 -57 28 c-44 21 -71 27 -121 27 -58 0
-70 -4 -126 -40z"/>
<path d="M3115 1285 c-14 -13 -25 -28 -25 -34 0 -8 36 -8 65 0 6 2 20 -2 33
-9 12 -7 22 -10 22 -7 0 2 25 -11 55 -30 30 -19 58 -35 62 -35 4 0 -36 29 -90
63 -53 35 -94 66 -90 70 3 4 3 7 -1 7 -4 0 -18 -11 -31 -25z"/>
<path d="M3015 1150 c-8 -13 15 -24 27 -12 6 6 4 11 -6 15 -8 3 -18 2 -21 -3z"/>
<path d="M2545 1142 c6 -6 39 -18 73 -27 48 -12 67 -13 77 -5 8 7 19 9 24 5 6
-3 23 1 38 10 19 10 21 14 8 11 -79 -18 -139 -15 -211 10 -13 5 -16 4 -9 -4z"/>
<path d="M2208 1103 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4568 1093 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2390 1045 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M4326 1045 c4 -8 10 -15 15 -15 4 0 6 7 3 15 -4 8 -10 15 -15 15 -4
0 -6 -7 -3 -15z"/>
<path d="M2901 1004 c-17 -25 -28 -51 -25 -57 4 -7 3 -9 -1 -4 -5 4 -16 0 -26
-9 -16 -15 -17 -18 -3 -40 l16 -23 44 37 c25 20 46 35 47 33 1 -2 12 1 25 8
22 11 23 11 13 -6 -5 -11 -30 -38 -55 -61 -25 -23 -42 -42 -38 -42 5 0 13 5
20 12 6 6 14 9 17 6 4 -3 -8 -12 -24 -19 -17 -8 -31 -17 -31 -21 0 -12 28 -10
35 2 3 6 15 10 26 10 10 0 19 4 19 8 0 13 59 31 66 20 4 -5 15 -2 28 10 11 10
27 22 34 27 20 11 -12 -47 -49 -90 -17 -19 -27 -35 -21 -35 5 0 13 7 16 16 3
8 10 12 16 9 8 -5 93 54 110 77 3 4 12 3 20 -2 26 -17 30 -11 7 13 -36 38
-128 102 -193 135 l-61 30 -32 -44z"/>
<path d="M3720 1013 c-81 -45 -145 -91 -189 -137 -34 -36 -34 -51 0 -20 23 21
45 13 99 -35 31 -27 47 -36 52 -28 6 9 8 9 8 0 0 -7 5 -13 11 -13 6 0 -1 14
-15 31 -15 17 -34 45 -42 61 -15 29 -15 29 5 18 12 -6 21 -15 21 -20 0 -6 15
-10 33 -10 17 0 51 -11 75 -25 37 -21 44 -22 49 -9 4 10 -11 33 -43 65 -26 26
-45 51 -42 55 11 10 76 -27 93 -53 12 -18 22 -23 39 -19 16 4 35 -5 70 -34 27
-22 51 -40 53 -40 5 0 -69 85 -87 100 -3 3 -29 38 -59 78 -29 39 -56 72 -59
72 -4 0 -36 -17 -72 -37z"/>
<path d="M4360 971 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3
-10 2 -10 -4z"/>
<path d="M2350 959 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2790 864 c-14 -19 -36 -41 -50 -49 -14 -8 -20 -14 -13 -15 13 0 103
75 104 87 1 20 -18 9 -41 -23z"/>
<path d="M3845 809 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z"/>
<path d="M2629 501 c-9 -4 -15 -25 -16 -63 l-1 -58 44 0 c28 0 43 4 39 10 -3
6 -17 10 -31 10 -32 0 -34 37 -1 43 l22 4 -22 2 c-16 1 -23 7 -23 20 0 15 8
21 33 23 l32 3 -31 6 c-17 3 -38 3 -45 0z"/>
<path d="M2730 490 c-23 -23 -25 -48 -8 -85 12 -27 54 -35 76 -13 19 19 14 33
-6 15 -25 -23 -41 -21 -51 6 -20 53 13 99 47 65 6 -6 15 -8 19 -4 9 9 -24 36
-44 36 -7 0 -22 -9 -33 -20z"/>
<path d="M2833 499 c-15 -5 -14 -7 7 -10 23 -4 25 -8 25 -56 0 -29 3 -53 7
-53 4 0 8 24 8 54 0 52 1 55 28 58 21 3 18 5 -15 9 -23 2 -50 2 -60 -2z"/>
<path d="M2962 494 c-26 -18 -30 -74 -6 -98 18 -19 55 -21 72 -4 19 19 15 82
-6 101 -23 21 -32 21 -60 1z m56 -45 c4 -43 -19 -69 -43 -49 -15 13 -21 71 -8
84 4 4 16 6 28 4 15 -2 21 -12 23 -39z"/>
<path d="M3255 499 c-22 -3 -30 -7 -17 -8 20 -1 22 -6 22 -56 0 -30 3 -55 8
-55 4 0 7 23 7 52 0 47 2 53 25 58 39 9 2 17 -45 9z"/>
<path d="M3339 501 c-1 -3 -2 -32 -3 -63 l-1 -58 43 0 c26 0 41 4 37 10 -3 6
-19 10 -35 10 -23 0 -27 3 -23 20 4 13 14 20 32 21 25 1 25 2 -4 8 -38 8 -40
35 -2 39 15 2 27 6 27 10 0 9 -70 12 -71 3z"/>
<path d="M3565 499 c-23 -5 -25 -7 -7 -8 20 -1 22 -6 22 -56 0 -30 5 -55 10
-55 6 0 10 24 10 54 0 49 2 55 23 58 21 3 21 4 -3 9 -14 2 -38 2 -55 -2z"/>
<path d="M3733 502 l-33 -3 0 -60 0 -59 40 0 c44 0 55 14 13 18 -32 3 -37 7
-30 27 4 8 19 16 34 16 l28 1 -30 7 c-43 9 -45 39 -3 43 18 2 29 5 23 8 -5 3
-25 4 -42 2z"/>
<path d="M3823 499 c-20 -7 -23 -29 -14 -111 1 -5 6 -8 12 -8 5 0 7 5 4 10
-12 20 6 52 26 47 10 -3 22 -1 25 4 3 5 -9 9 -25 9 -24 0 -31 4 -31 19 0 15 8
21 33 23 25 2 28 4 12 9 -12 3 -30 3 -42 -2z"/>
<path d="M3928 502 c-20 -4 -26 -41 -18 -107 2 -14 4 -11 9 10 5 23 13 31 36
36 l30 7 -33 1 c-26 1 -33 5 -30 18 2 11 16 20 33 23 24 5 26 7 10 11 -11 3
-28 3 -37 1z"/>
<path d="M4011 501 c-5 -3 -9 -32 -9 -63 l1 -58 38 0 c22 0 39 4 39 8 0 4 -12
8 -27 8 -41 -1 -39 37 2 45 l30 6 -30 4 c-44 6 -46 37 -3 41 l33 3 -32 6 c-18
3 -37 3 -42 0z"/>
<path d="M4120 490 c-37 -37 -19 -110 29 -110 15 0 34 7 41 15 18 22 5 31 -15
11 -20 -19 -27 -20 -43 -4 -13 13 -16 47 -6 72 7 19 35 21 52 4 6 -6 14 -9 17
-6 8 8 -24 38 -41 38 -8 0 -23 -9 -34 -20z"/>
<path d="M4214 498 c-3 -5 4 -8 15 -8 19 0 21 -6 21 -55 0 -30 5 -55 10 -55 6
0 10 25 10 55 0 48 2 55 20 55 11 0 20 4 20 9 0 10 -90 9 -96 -1z"/>
<path d="M2511 441 c12 -34 27 -61 34 -61 7 0 19 21 26 48 7 26 15 53 17 60 2
6 -1 12 -7 12 -5 0 -16 -21 -23 -47 l-14 -48 -15 44 c-8 25 -20 46 -27 49 -7
2 -3 -20 9 -57z"/>
<path d="M3070 440 c0 -33 4 -60 10 -60 6 0 10 11 10 25 0 14 6 25 13 25 8 0
19 -11 25 -25 6 -14 16 -25 22 -25 7 0 7 7 -1 21 -8 16 -8 28 0 45 17 37 4 54
-40 54 l-39 0 0 -60z m65 40 c8 -13 -13 -40 -31 -40 -8 0 -14 10 -14 25 0 18
5 25 19 25 11 0 23 -5 26 -10z"/>
<path d="M3445 483 c16 -39 16 -52 0 -77 -15 -23 -15 -26 -2 -26 9 0 19 9 22
20 3 11 10 20 15 20 5 0 12 -9 15 -20 3 -11 13 -20 21 -20 12 0 12 4 -3 26
-14 22 -15 31 -5 57 14 37 6 50 -14 22 -14 -19 -16 -19 -28 -2 -7 9 -17 17
-21 17 -4 0 -4 -8 0 -17z"/>
<path d="M2721 264 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3661 264 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
